import React from "react";
import PropTypes from "prop-types";
import ModalToBody from "../../../base/ModalToBody";
import { Trans } from "react-i18next";
import {
  ajaxErrorHandler,
  defaultDayFormater,
  defaultSuccess
} from "../../../libs/utils";
import { updateMaterialRequestDay } from "../../../services/api/materialRequests";

class MaterialRequestDayButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };

    this._hideModal = this._hideModal.bind(this);
    this._showModal = this._showModal.bind(this);
    this._updateRequest = this._updateRequest.bind(this);
  }

  static propTypes = {
    request: PropTypes.object,
    admin: PropTypes.bool,
    registrationId: PropTypes.number
  };

  _showModal() {
    this.setState({
      showModal: true
    });
  }

  _hideModal() {
    this.setState({
      showModal: false
    });
  }

  _updateRequest(e, day) {
    updateMaterialRequestDay(
      this.props.registrationId,
      day.materialRequestId,
      day.id,
      { quantity: e.target.value }
    )
      .then(response => defaultSuccess("Updated"))
      .catch(ajaxErrorHandler);
  }

  render() {
    const { showModal } = this.state;
    const { request, admin } = this.props;

    if (showModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return [
      <span key="button">
        <button
          className="btn btn-outline-accent m-btn btn-sm  m-btn--icon m--margin-left-5"
          onClick={this._showModal}
        >
          <span>
            <i className="la la-map-marker" />
            <span>Amounts</span>
          </span>
        </button>
      </span>,

      <ModalToBody key="modal" render={showModal}>
        <div
          className="modal fade show"
          id="m_modal_4"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1039"
          }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <Trans>Amounts</Trans>
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this._hideModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Day</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {request.days?.map(day => (
                      <tr key={day.id}>
                        <td>{defaultDayFormater(day.day)}</td>
                        <td>
                          {admin ? (
                            <input
                              type="number"
                              className="form-control m-input"
                              defaultValue={day.quantity}
                              onBlur={e => this._updateRequest(e, day)}
                            />
                          ) : (
                            day.quantity
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div
          className={"modal-backdrop fade " + (showModal ? " show" : "")}
          style={{
            display: showModal ? "block" : "none",
            zIndex: "1038"
          }}
        />
      </ModalToBody>
    ];
  }
}

export default MaterialRequestDayButton;
